import CheckboxGroup, { type CheckboxGroupItem } from "@/components/molecules/CheckboxGroup/CheckboxGroup";
import React, { useMemo } from "react";

export type ManagedTagsProps = {
  items: CheckboxGroupItem[];
  onClick: (checked: string[]) => void;
  maxChecked?: number;
  className?: string;
  title?: string;
};

export default function ManagedTags({ items, onClick, maxChecked, className = "", title }: ManagedTagsProps) {
  const processedItems = useMemo(() => {
    const checkedCount = items.filter((it) => it.isChecked).length;
    return items.map((it) =>
      !it.isChecked && maxChecked && checkedCount >= maxChecked ? { ...it, isDisabled: true } : it,
    );
  }, [items, maxChecked]);

  const handleItemClick = (id: string | number) => {
    const idStr = String(id);
    const current = items.filter((it) => it.isChecked).map((it) => String(it.id));
    const isCurrentlyChecked = current.includes(idStr);
    let next = isCurrentlyChecked ? current.filter((x) => x !== idStr) : [...current, idStr];
    // If maxChecked is defined and we're adding, enforce the cap (UI also disables, this is a safeguard)
    if (!isCurrentlyChecked && typeof maxChecked === "number" && maxChecked > 0 && next.length > maxChecked) {
      next = current; // ignore the add
    }
    onClick(next);
  };

  return (
    <div className={className}>
      <CheckboxGroup items={processedItems} onClick={handleItemClick} title={title} />
    </div>
  );
}
